import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { Link, useHistory, useParams, Redirect} from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../../services/apiResponse'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import DetailBloc from './Blocs/DetailBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar';
import CustomSelect from '../../../GlobalComponents/CustomSelect'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'


const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};


class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            country_id:"",
            uuid : "",
            optionStatusApproval : [
                { label: "Disetujui", value: 1 },
                { label: "Ditolak", value: 2 }
              ],
        }
    }

    componentDidMount() {


        this.detailBloc.approveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response_current = result.data.response.current
                        let response_history = result.data.response.history
                        this.setState({
                            country_id: response_current.keluarga_orangtua_of_birth_country_uuid,
                            detail: response_current,
                            dataForm: {
                              status: 1,
                              uuid : response_current.family_uuid
                            },
                            history: response_history
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid'), history: 1 })

        this.setState({
            "uuid": queryParams.get('uuid')
        })

        /* 
            If Administrator
            Set Employee Selected on localstorage by Notification Click 
        */
        try {
            let causer = queryParams.get('causer')

            if (causer != null){
                let arrCauser = atob(causer).split('|');
    
                let dataUser = {
                    employee_uuid: arrCauser[1],
                    employee_name : arrCauser[0],
                    employee_current_position_name : arrCauser[2],
                    employee_nip : arrCauser[3]
                }
                localStorage.setItem('employeeSelected', JSON.stringify(dataUser))
                //console.log(arrCauser);
            }
        } catch (error) {}
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                employee_uuid: this.state.detail.family_employee_uuid,
                ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        console.log(this.state.dataForm)
        await this.detailBloc.fetchApprove(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="orangtua"/>

                            <Card className="pegawai-rightbar">
                                <AvForm
                                    className="needs-validation"
                                    onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                >

                                <CardBody>
                                    <CardTitle>Approve Orang Tua</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Informasi Detail Orang Tua
                                    </CardSubtitle>
                                    <hr />

                                    {
                                        this.state.history ?
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                
                                            </label>
                                            <Col md="5">
                                                <strong> Data Baru </strong>
                                            </Col>
                                            <Col md="4">
                                                <strong className="text-danger"> Data Lama </strong>
                                            </Col>
                                        </Row>
                                    : '' }

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Lengkap
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_name !== "" ? this.state.detail.family_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_name !== "" ? this.state.history.family_name : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Posisi Dalam Keluarga
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_parent_type !== "" ? this.state.detail.family_parent_type : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_parent_type !== "" ? this.state.history.family_parent_type : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nomor Induk Kependudukan
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_number !== "" ? this.state.detail.family_identity_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_identity_number !== "" ? this.state.history.family_identity_number : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nomor Kartu Keluarga
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.familty_family_card_number !== "" ? this.state.detail.familty_family_card_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.familty_family_card_number !== "" ? this.state.history.familty_family_card_number : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>


                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Jenis Kelamin
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_gender !== "" ? this.state.detail.family_gender : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_gender !== "" ? this.state.history.family_gender : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <hr />
                                    <Row>
                                        <Col md="5">
                                            <label className="fw-bold">#Tempat Lahir</label>
                                        </Col>
                                    </Row>

                                    {this.state.detail && this.state.detail.family_place_of_birth_country_uuid == '61b47307-167d-489f-bb6c-c1c9662acab3' ? (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Dalam / Luar Negeri 
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ? <>{'Dalam Negeri'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{'Dalam Negeri' !== "" ? 'Dalam Negeri' : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Dalam / Luar Negeri 
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ? <>{'Luar Negeri'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{'Luar Negeri' !== "" ? 'Luar Negeri' : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    )}       
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Negara
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_place_of_birth_country_name !== "" ? this.state.detail.family_place_of_birth_country_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_place_of_birth_country_name !== "" ? this.state.history.family_place_of_birth_country_name : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    {this.state.detail && this.state.detail.family_place_of_birth_country_uuid == '61b47307-167d-489f-bb6c-c1c9662acab3' ? (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Provinsi
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_identity_province_name !== "" ? this.state.detail.family_identity_province_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_identity_province_name !== "" ? this.state.history.family_identity_province_name : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    ) : (
                                        <small></small>
                                    )}       

                                    {this.state.detail && this.state.detail.family_place_of_birth_country_uuid == '61b47307-167d-489f-bb6c-c1c9662acab3' ? (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kabupaten / Kota
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_place_of_birth_city_name !== "" ? this.state.detail.family_place_of_birth_city_name : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_place_of_birth_city_text !== "" ? this.state.history.family_place_of_birth_city_text : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    ) : (
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Kota
                                            </label>
                                            <Col md="5">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.family_place_of_birth_city_text !== "" ? this.state.detail.family_place_of_birth_city_text : '-'}</>
                                                    : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                            <Col md="4">
                                                {
                                                    this.state.history ?
                                                        <>{this.state.history.family_place_of_birth_city_text !== "" ? this.state.history.family_place_of_birth_city_text : '-'}</>
                                                    : ""
                                                }
                                            </Col>
                                        </Row>
                                    )}       


                                    <hr />
                                  
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal Lahir 
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_date_of_birth !== "" ? reformatDate(this.state.detail.family_date_of_birth) : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_date_of_birth !== "" ? reformatDate(this.state.history.family_date_of_birth) : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_is_alive_status !== "" ? this.state.detail.family_is_alive_status : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_is_alive_status !== "" ? this.state.history.family_is_alive_status : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <hr />
                                    <Row>
                                        <Col md="5">
                                            <label className="fw-bold">#Informasi Lainnya</label>
                                        </Col>
                                    </Row> 


                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                         Pekerjaan
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_profession !== "" ? this.state.detail.family_profession : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_profession !== "" ? this.state.history.family_profession : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Provinsi
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_province_name !== "" ? this.state.detail.family_identity_province_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_identity_province_name !== "" ? this.state.history.family_identity_province_name : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Kabupaten / Kota
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_city_name !== "" ? this.state.detail.family_identity_city_name : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_identity_city_name !== "" ? this.state.history.family_identity_city_name : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Kode Pos
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_postal_code !== "" ? this.state.detail.family_identity_postal_code : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_identity_postal_code !== "" ? this.state.history.family_identity_postal_code : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Telepon
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_phone_number !== "" ? this.state.detail.family_phone_number : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_phone_number !== "" ? this.state.history.family_phone_number : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Alamat Lengkap
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.family_identity_address !== "" ? this.state.detail.family_identity_address : '-'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.family_identity_address !== "" ? this.state.history.family_identity_address : '-'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>
                                     <Row className="mb-3">
                                        <label className="col-md-3">
                                         Dokumen
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.document != null ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.detail.document?.documents_path}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                        <Col md="4">
                                            {
                                                this.state.history ?
                                                    <>{this.state.history.document != null ? 
                                                    <a target="_blank" rel="noreferrer" class="btn btn-sm btn-primary" href={this.state.history.document?.documents_path}>
                                                        <i className="uil-file-download"></i> Download File
                                                    </a>
                                                    : 'Tidak ada dokumen'}</>
                                                : ""
                                            }
                                        </Col>
                                    </Row>

                                    {/* <Row className="mb-3">
                                        <label className="col-md-3">
                                         Status
                                        </label>
                                        <Col md="5">
                                            {
                                                this.state.detail ?
                                                    <>{parseInt(this.state.detail.keluarga_orangtua_status) === 1 ? 
                                                        <label className="badge rounded-pill bg-soft-success font-size-12" >Approve</label>
                                                    : <label className="badge rounded-pill bg-soft-warning font-size-12" >Menunggu Approve</label>}</>
                                                : <Shimmer><div style={{width: 68, height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row> */}

                                    <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="uuid"
                                            value={this.state.uuid}
                                    />

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status Approval <span className="text-danger">*</span>
                                        </label>
                                        <Col md="3">
                                            <CustomSelect 
                                                name="status_approval"
                                                errorMessage="Pilih Status Approval"
                                                options={this.state.optionStatusApproval} 
                                                placeholder="Pilih Status Approval"
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label
                                            htmlFor="status_approval_description"
                                            className="col-md-3 col-form-label"
                                        >
                                        Keterangan Approval <span className="text-danger">*</span>
                                        </label>
                                        <Col md="5">
                                            <AvField
                                                name="status_approval_description"
                                                placeholder="Keterangan Approval..."
                                                type="textarea"
                                                errorMessage="Masukkan Keterangan Approval"
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                id="status_approval_description"
                                            />
                                        </Col>
                                    </Row>
                                   
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="5">
                                        <Button 
                                                  color="success" 
                                                  type="submit"
                                                >
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                                {' '}
                                                <Link to="/kepegawaian/home.html?orangtua">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                        </Col>
                                    </Row>
                                </CardBody>

                            </AvForm>

                                
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin ?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil diverifikasi"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal diverifikasi"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={`/kepegawaian/home.html?orangtua`}/>
                : null }                                   

            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);